import React from "react";
import { BackgroundImage, TeethLogo, ServiceBottomButton } from "../../Components"
import pedodontic_dentistry from "../../assets/Images/pedodontic-dentistry-home.jpg"

const PedodonticDentistry = (props) => {
    const { selectedLanguage } = props

    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.services_perdodontic_dentistry_heading} text={selectedLanguage?.txt_explore_our_services} mainClass='pedodontic-dentistry-background' />
            <TeethLogo heading={selectedLanguage?.services_perdodontic_dentistry_heading} />
            <div className="dental-service-main">
                <div className="dental-service-img-div">
                    <img src={pedodontic_dentistry} alt="dentalImg" />
                </div>
                <div className="dental-service-text-div">
                    <p>{selectedLanguage?.txt_a_wide_range_of_dental_treatment_are_applicable_in_pedondontic}
                    </p>
                    <ul>
                        <li>{selectedLanguage?.txt_dental_education}</li>
                        <li>{selectedLanguage?.txt_monitoring_of_the_dental_eruption}</li>
                        <li>{selectedLanguage?.txt_child_dietary_consulation}</li>
                        <li>{selectedLanguage?.txt_fluoride_treatment}</li>
                        <li>{selectedLanguage?.txt_filling_of_deciduous_teeth}</li>
                        <li>{selectedLanguage?.txt_sealant_of_the_permanenr_teeth}</li>
                        <li>{selectedLanguage?.txt_space_maintainer}</li>
                        <li>{selectedLanguage?.txt_space_regainer}</li>
                        <li>{selectedLanguage?.txt_Root_canal_treatment}</li>
                        <li>{selectedLanguage?.txt_stainless_steel_crown_of_the_deciduous_teeth}</li>
                        <li>{selectedLanguage?.txt_routine_dental_check_up}</li>
                    </ul>
                </div>
            </div>
            <ServiceBottomButton {...props} />
        </div>
    )
}

export default PedodonticDentistry